module.exports = __webpack_public_path__ + "img/icon_cloud-download.74a32a37.svg";